import styled from "styled-components";
import { shade } from "polished";

import background from "../../assets/foto_polo_filter.jpg";

export const Container = styled.div`
  height: 100vh;

  background: url(${background}) no-repeat;
  background-size: cover;

  display: flex;
  align-items: center;
  justify-content: center;

  div {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    padding: 15px;
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    img {
      width: 12vw;
    }

    h1 {
      margin-top: 30px;
    }

    h2 {
      font-weight: 400;
    }

    a {
      margin-top: 30px;
      color: #5271ff;
      font-size: 1.8rem;
      opacity: 0.8;
      text-decoration: none;
      transition: background 0.2s;

      display: flex;
      align-items: center;

      svg {
        margin-right: 7px;
      }

      &:hover {
        color: ${shade(0.05, "#5271ff")};
      }
    }
  }
`;
